import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { IContactCreditScore } from './ContactCreditScore.interface';
import { ContactCreditScoreType } from './ContactCreditScoreType.enum';

export default class ContactCreditScore implements IContactCreditScore {
  id: string;
  idTicket: string;
  idAccount: string;
  enquiryId: string;
  bureauReference: string;
  score: number;
  keyFactors: Array<any>;
  type: string;
  timeStamp: number;

  static build = (data: IContactCreditScore) => new ContactCreditScore(data);
  static blank = () => new ContactCreditScore();

  /**
   * Constructor
   * @param {IContactCreditScore} data
   */
  constructor(data?: IContactCreditScore) {
    this.id = toUUID(data?.id) || uuid();
    this.idTicket = toUUID(data?.idTicket);
    this.idAccount = toUUID(data?.idAccount);
    this.enquiryId = data?.enquiryId || undefined;
    this.bureauReference = data?.bureauReference || undefined;
    this.score = parseInt(data?.score || 0, 10);
    this.keyFactors = data?.keyFactors || [];
    this.type = ContactCreditScoreType.of(data?.type?.name || data?.type?.toString());
    // TODO: data?.timestamp is legacy data structure
    this.timeStamp = epoch(utc(data?.timeStamp || data?.timestamp));
  }
}
